import { ContextType } from '@charlesschwab/as-ui-core';

export function isPalAccountFlow(contextType: ContextType, isPalWireCreateTransactionEnabled: boolean): boolean {
  return contextType === ContextType.PALAccount && isPalWireCreateTransactionEnabled;
}